import { flatten } from "flat";

import Tokens from "./semantic";
import { ColorTokenName } from "./types";

export const COLOR_TOKEN_NAMES = Object.keys(
  flatten(Tokens)
) as ColorTokenName[];

export const DEFAULT_COLOR_TOKEN_SET_NAME_PREFIX = "Core." as const;
